import Vue from 'vue'
import Router from 'vue-router'
import homePage from '@/components/ZH-CN/homePage'

import levalPage from '@/components/ZH-CN/levalPage'
 import detailPage from '@/components/ZH-CN/detailsPage'
import memberPage from '@/components/ZH-CN/memberPage'
import surveyPage from '@/components/ZH-CN/jjgkPage'
import aboutPage from '@/components/ZH-CN/aboutPage'

import logonPage from '@/components/logonPage'
import loginPage from '@/components/loginPage'



import msgPage from '@/components/msgPage'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: homePage
    },{
      path: '/leval',
      name: 'levalPage',
      component: levalPage,

      
    },{
      path:"/detail",
      name:"detailPage",
      component:detailPage
    },{
      path:"/member",
      name: 'memberPage',
      component: memberPage
    },{
      path:"/logon",
      name: 'logonPage',
      component: logonPage
    },{
      path:"/login",
      name: 'loginPage',
      component: loginPage
    },{
      path:"/survey",
      name: 'surveyPage',
      component: surveyPage
    },{
      path:"/msg",
      name: 'msgPage',
      component: msgPage
    },{
      path:"/about",
      name: 'aboutPage',
      component: aboutPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js